export const FETCH_HISTORY = 'FETCH_HISTORY';
export const FETCH_HISTORY_SUCCESS = 'FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_FAIL = 'FETCH_HISTORY_FAIL';

export const fetchHistory = ({ caseId, currentHistoryPage }) => ({
  type: FETCH_HISTORY,
  payload: { caseId, currentHistoryPage }
});

export const fetchHistorySuccess = ({ list, total }) => ({
  type: FETCH_HISTORY_SUCCESS,
  payload: { list, total }
});

export const fetchHistoryFail = () => ({
  type: FETCH_HISTORY_FAIL
});
